import React, { useState } from "react";

function HealthCenterGallery() {
    const Data = [
        {
            img: "https://files.iittp.ac.in/pics/healthcenter/amb1.jpg",
            category: "ambulance",
        },

        {
            img: "https://files.iittp.ac.in/pics/healthcenter/amb2.jpg",
            category: "ambulance",
        },

        {
            img: "https://files.iittp.ac.in/pics/healthcenter/1.jpg",
            category: "bloodDonationCamp",
        },
        {
            img: "https://files.iittp.ac.in/pics/healthcenter/2.jpg",
            category: "bloodDonationCamp",
        },
        {
            img: "https://files.iittp.ac.in/pics/healthcenter/3.jpg",
            category: "bloodDonationCamp",
        },
        {
            img: "https://files.iittp.ac.in/pics/healthcenter/4.jpg",
            category: "bloodDonationCamp",
        },

        {
            img: "https://files.iittp.ac.in/pics/healthcenter/5.jpg",
            category: "dayCare",
        },

        {
            img: "https://files.iittp.ac.in/pics/healthcenter/6.jpg",
            category: "covidScreeningTests",
        },

        {
            img: "https://files.iittp.ac.in/pics/healthcenter/7.jpg",
            category: "certificates",
        },
    ];

    const [current, setcurrent] = useState(Data);
    const [filterState, setFilterState] = useState("View All");

    const Filter = (category) => {
        const arr = [];
        if (category === "View All") {
            setcurrent(Data);
            setFilterState("View All");
        } else {
            Data.map((item) => {
                if (item.category === category) {
                    arr.push(item);
                }
                return null;
            });
            setcurrent(arr);
            setFilterState(category);
        }
    };

    const isActive = (value) => {
        return filterState === value ? "active" : "";
    };

    return (
        <>
            <section id="work" className="pb-105">
                <div className="container">
                    <div className="portfolio ">
                        <div className="row align-items-end">
                            <div className="col-lg-12">
                                <div
                                    className="my-masonry text-center mb-50 wow fadeInRight  animated"
                                    data-animation="fadeInRight"
                                    data-delay=".4s"
                                >
                                    <div className="button-group filter-button-group ">
                                        <button
                                            className={isActive("View All")}
                                            data-filter="*"
                                            onClick={() => Filter("View All")}
                                        >
                                            {" "}
                                            View All{" "}
                                        </button>
                                        <button
                                            className={isActive("ambulance")}
                                            data-filter=".ambulance"
                                            onClick={() => Filter("ambulance")}
                                        >
                                            Ambulance
                                        </button>
                                        <button
                                            className={isActive(
                                                "bloodDonationCamp"
                                            )}
                                            data-filter=".bloodDonationCamp"
                                            onClick={() =>
                                                Filter("bloodDonationCamp")
                                            }
                                        >
                                            Blood Donation Camp
                                        </button>
                                        <button
                                            className={isActive("dayCare")}
                                            data-filter=".dayCare"
                                            onClick={() => Filter("dayCare")}
                                        >
                                            Day Care Treatment{" "}
                                        </button>
                                        <button
                                            className={isActive(
                                                "covidScreeningTests"
                                            )}
                                            data-filter=".covidScreeningTests"
                                            onClick={() =>
                                                Filter("covidScreeningTests")
                                            }
                                        >
                                            Covid Screening Tests
                                        </button>
                                        <button
                                            className={isActive("certificates")}
                                            data-filter=".certificates"
                                            onClick={() =>
                                                Filter("certificates")
                                            }
                                        >
                                            Certificates
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="grid col3 row wow fadeInUp  animated"
                            data-animation="fadeInUp"
                            data-delay=".4s"
                        >
                            {current.map((item, Index) => (
                                <div
                                    className="grid-item financial col-4"
                                    key={Index}
                                >
                                    <figure className="gallery-image">
                                        <img
                                            src={item.img}
                                            alt="img"
                                            className="img"
                                        />
                                    </figure>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default HealthCenterGallery;
